<script setup>
  import MainLayout from '@/features/layout/MainLayout.vue'
  import { useSuperAdminSidebarMenuLinks } from '@/features/layout/components/constants/useSuperAdminSidebarMenuLinks.js'

  const title = 'Super Admin'
  const menuLinks = useSuperAdminSidebarMenuLinks()
</script>

<template>
  <MainLayout :hamburger-title="title" :sidebar-links="menuLinks"> </MainLayout>
</template>

<style lang="scss" scoped></style>
